import React, { Fragment } from "react";
import Moment from "react-moment";

const UserResume = ({
  setShowResume,
  profile: {
    avatar,
    firstname,
    lastname,
    jobtitle,
    location,
    resume: { professionalsummary, education, experience, skills },
  },
}) => {
  return (
    <Fragment>
      <div className="modal-overlay">
        <div className="resume-view">
          <i
            className="fas fa-times fa-2x message-x"
            onClick={() => setShowResume(false)}
          ></i>
          <div className="flex-center">
            <div className="online-avi-container">
              <div className="avi-color-border green">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                  className="drop-down-result-avi"
                  alt="avatar"
                />
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="green name-font bold">
                    {firstname} {lastname}
                  </span>
                </li>
                <li className="user-online-item">{jobtitle}</li>
                <li className="user-online-item">
                  {location.city}, {location.state}
                </li>
              </ul>
            </div>
          </div>
          {professionalsummary === "" &&
          education.length <= 0 &&
          experience.length <= 0 &&
          skills.length <= 0 ? (
            <div className="no-user-content">
              <p className="no-content-message green bold">
                No Resume Available
              </p>
            </div>
          ) : (
            <div className="applicant-info">
              <div className="single-section">
                <div className="flex-only">
                  <p className="sub-section green">Professional Summary</p>
                </div>
                <p className="summary">{professionalsummary}</p>
              </div>
              {education.length > 0 &&
                education.map((item) => {
                  return (
                    <div className="single-section" key={item._id}>
                      <div className="lower-section">
                        <div>
                          <p className="sub-section-years green">Education</p>
                          <div className="app-years">
                            <p className="app-year green">
                              <Moment format="MM/DD/YYYY">{item.from}</Moment> -{" "}
                              <Moment format="MM/DD/YYYY">{item.to}</Moment>
                            </p>
                          </div>
                        </div>
                        <div className="side-info">
                          <p className="applicant-side-title">
                            {item.institution}
                          </p>
                          <ul className="education-items">
                            {item.description.map((listitem) => {
                              return (
                                <li
                                  className="education-item"
                                  key={listitem._id}
                                >
                                  <i class="fas fa-asterisk mr-5 white fa-sm"></i>
                                  {listitem.item}
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                    </div>
                  );
                })}
              {experience.length > 0 &&
                experience.map((item) => {
                  return (
                    <div className="single-section">
                      <div className="lower-section">
                        <div>
                          <p className="sub-section-years green">Experience</p>
                          <div className="app-years">
                            <p className="app-year green">
                              <Moment format="MM/DD/YYYY">{item.from}</Moment> -{" "}
                              <Moment format="MM/DD/YYYY">{item.to}</Moment>
                            </p>
                          </div>
                        </div>
                        <div className="side-info">
                          <p className="applicant-side-title">
                            {item.employer}
                          </p>
                          <ul className="education-items">
                            {item.description.map((listitem) => {
                              return (
                                <li
                                  className="education-item"
                                  key={listitem._id}
                                >
                                  <i class="fas fa-asterisk mr-5 white fa-sm"></i>
                                  {listitem.item}
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                    </div>
                  );
                })}
              {skills.length > 0 &&
                skills.map((item) => {
                  return (
                    <div className="single-section">
                      <div className="lower-section">
                        <div>
                          <p className="sub-section-years green">Skills</p>
                          <div className="app-years">
                            <p className="app-year green">
                              <Moment format="MM/DD/YYYY">{item.from}</Moment> -{" "}
                              <Moment format="MM/DD/YYYY">{item.to}</Moment>
                            </p>
                          </div>
                        </div>
                        <div className="side-info">
                          <p className="applicant-side-title">
                            {item.skillname}
                          </p>
                          <ul className="education-items">
                            {item.description.map((listitem) => {
                              return (
                                <li
                                  className="education-item"
                                  key={listitem._id}
                                >
                                  <i class="fas fa-asterisk mr-5 white fa-sm"></i>
                                  {listitem.item}
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default UserResume;
